export const uk = {
    'date-placeholder': 'дд.мм.гггг',
    'number-set-placeholder': 'значение, другое значение, ...',
    'your-value': 'ваше значение'
};
